import React, {PureComponent} from "react"
import styled from "styled-components"
import {Body} from "@irati/ui/src/Typography"
import {Poll} from "@irati/types"
import {injectIntl, FormattedMessage, InjectIntl} from "@irati/utils/lang"
import Confirm from "../../../shared/Confirm"

interface Props extends InjectIntl {
  className?: string
  poll: Poll
}

class ConfirmDeletePollBase extends PureComponent<Props> {
  render() {
    const {intl, poll, ...props} = this.props
    const confirmLabel = intl.formatMessage({id: "recognition.polls.openPoll.poll.confirm.delete.confirmLabel"})
    const numVotes = poll.votes.results.length

    return (
      <Confirm confirmLabel={confirmLabel} {...props}>
        <Body small marginBottom={1}>
          <FormattedMessage id="recognition.polls.openPoll.poll.confirm.delete.message" values={{numVotes}} />
        </Body>
      </Confirm>
    )
  }
}

const ConfirmDeletePoll = styled(ConfirmDeletePollBase)`
  position: absolute;
  top: 0;
  right: 0;
  margin-top: 5px;
  z-index: 10;
  text-align: left;
`

export default injectIntl(ConfirmDeletePoll)
